import { BaseFamily } from '../../../shared/src/types/Family';
import { baseApi } from '../app/baseApi';

export const mentorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInactiveFamilies: builder.query<BaseFamily[], void>({
      query: () => ({
        url: 'mentor/inactive-families',
        method: 'GET',
        credentials: 'include',
      }),
      transformResponse: (response: { success: boolean; data: BaseFamily[] }) => response.data,
      
    }),
  }),
  overrideExisting: false,
});

export const { useGetInactiveFamiliesQuery } = mentorApi;